const asNumber = (v) => typeof v === "number" ? v : parseFloat(v);

export { asNumber };
//# sourceMappingURL=as-number.mjs.map
